export interface ScreenDistance {
  inches: number;
  cm: number;
  min: number;
  max: number;
}

export const SCREEN_DISTANCES: ScreenDistance[] = [
  { inches: 13, cm: 33.1, min: 45, max: 54 },
  { inches: 14, cm: 35.6, min: 48, max: 59 },
  { inches: 15, cm: 38.1, min: 51, max: 63 },
  { inches: 16, cm: 40.6, min: 55, max: 67 },
  { inches: 17, cm: 43.2, min: 58, max: 71 },
  { inches: 18, cm: 45.7, min: 62, max: 75 },
  { inches: 19, cm: 48.3, min: 65, max: 80 },
  { inches: 20, cm: 50.8, min: 69, max: 84 },
  { inches: 21, cm: 53.3, min: 72, max: 88 },
  { inches: 22, cm: 55.9, min: 75, max: 92 },
  { inches: 23, cm: 58.4, min: 79, max: 96 },
  { inches: 24, cm: 60.9, min: 82, max: 101 },
];

const DEFAULT_INCHES = 14;

export const defaultScreenSize = () => `${DEFAULT_INCHES} pouces`;

const SMALLEST = SCREEN_DISTANCES[0];
const LARGEST = SCREEN_DISTANCES[SCREEN_DISTANCES.length - 1];

export function getScreenDistance(screenSize: string): ScreenDistance {
  const match = (screenSize || "").match(/\d+/);
  if (!match) return SCREEN_DISTANCES.find((row) => row.inches === DEFAULT_INCHES) || SMALLEST;

  const inches = parseInt(match[0], 10);
  if (inches <= SMALLEST.inches) return SMALLEST;
  if (inches >= LARGEST.inches) return LARGEST;

  return SCREEN_DISTANCES.find((row) => row.inches === inches) || SMALLEST;
}
